/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ExtendContainerProps} from '@gongxigames/framework/core/fragments/BuilderY';
import {$UIText} from '../../../JSX/UIText';
import {$FixedValSlider} from '../../../JSX/FixedValSlider';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export type $AutoplayRoundsSelectorProps = ExtendContainerProps<{
    options: number[];
    roundsCount: number;
    action: (value: number) => void;
}>;

export const $AutoplayRoundsSelector: FC<$AutoplayRoundsSelectorProps> = (props) => {
    const {responsive, options, roundsCount, action} = props;

    const roundsCountStr = Store.computed(() => String(roundsCount));

    return <$Container
        responsive={responsive}
    >
        <$UIText
            localeID='numberOfAutospins'
            stylePreset='POPUP_TEXT_HIGHLIGH'
            maxWidth={900}
        />
        <$FixedValSlider
            values={options}
            value={roundsCount}
            size={'500px'}
            action={action}
            responsive={{
                box: {x: '0', y: '0'},
                translate: {x: '-325px', y: '80px'},
            }}
        />
        <$UIText
            text={roundsCountStr}
            stylePreset='POPUP_TEXT_BOLD'
            responsive={{
                box: {x: '0', y: '0'},
                translate: {x: '270px', y: '126px'},
            }}
        />
    </$Container>;
};
